export enum EpsRoutes {
    Root = "/mis-seguros/eps",
    PlanDetailV1 = "/v1/#/salud/:productCode/detalle-plan/:planNumber/:insuredCode",
    PlanDetail = "/mis-seguros/eps/:productCode/detalle-plan/:planNumber",
}
